export default __webpack_public_path__ + "static/media/html.2a8707d6.png";